export default {
  setGradesLoading (state, status) {
    state.gradesLoading = status
  },

  setGrades (state, grades) {
    state.grades = grades
  },

  addGrade (state, grade) {
    state.grades.push(grade)
  },

  removeGrade (state, gradeId) {
    state.grades = state.grades.filter(grade => grade.gradeId !== gradeId)
  },

  updateGrade (state, grade) {
    const index = state.grades.findIndex(v => v.gradeId === grade.gradeId)
    if (index !== -1) {
      Object.assign(state.grades[index], grade)
    }
  }
}
